export default function makeQueryParam(k, v) {
  return `${k}=${v}`;
}
